module.exports = __webpack_public_path__ + "media/images/sport-ba61fdea4dd011898ce7d19363194d75.jpg";